<template>
  <v-app class="platform-font">
    <main-app-bar />
    <v-main :full-screen="$root.fullScreenView">
      <router-view />
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import MainAppBar from "@/components/MainAppBar"
import constant from "../const"

(function(i, s, o, g, r, a, m) {
  i["GoogleAnalyticsObject"] = r;
  (i[r] =
    i[r] ||
    function() {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");

ga("create", "UA-136760541-1", "auto");
ga("send", "pageview");

export default {
  components: {
    MainAppBar
  },
  data: () => ({
    showSnackbar: false,
    snackbarColor: "",
    snackbarMsg: "",
    snackbarTimeout: 6000,
    username: null
  }),

  created() {},

  methods: {}
}
</script>

<style scoped></style>
